import React from 'react';
import { CheckCircleIcon, AlertCircleIcon, InfoIcon } from 'lucide-react';
import { RDRecommendation } from '../types';
interface RDGuidanceBadgeProps {
  recommendation: RDRecommendation;
  size?: 'sm' | 'md';
}
export function RDGuidanceBadge({
  recommendation,
  size = 'md'
}: RDGuidanceBadgeProps) {
  const sizeClasses = size === 'sm' ? 'text-xs px-2 py-1' : 'text-sm px-3 py-1.5';
  if (recommendation === 'recommended') {
    return <div className={`inline-flex items-center gap-1 bg-green-100 text-green-700 rounded-full font-medium ${sizeClasses}`} data-id="element-70">
        <CheckCircleIcon className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} data-id="element-71" />
        <span data-id="element-72">Plan Approved</span>
      </div>;
  }
  if (recommendation === 'limit') {
    return <div className={`inline-flex items-center gap-1 bg-amber-100 text-amber-700 rounded-full font-medium ${sizeClasses}`} data-id="element-73">
        <AlertCircleIcon className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} data-id="element-74" />
        <span data-id="element-75">Limit</span>
      </div>;
  }
  if (recommendation === 'ask') {
    return <div className={`inline-flex items-center gap-1 bg-blue-100 text-blue-700 rounded-full font-medium ${sizeClasses}`} data-id="element-76">
        <InfoIcon className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} data-id="element-77" />
        <span data-id="element-78">Ask RD</span>
      </div>;
  }
  return null;
}